import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { formatArrivalDate } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';

@Component({
  selector: 'usb-item-pthemes',
  templateUrl: './item-pthemes.component.html',
  styleUrls: ['./item-pthemes.component.scss']
})
export class ItemPthemesComponent implements OnInit {

  @Input() dato: any;
  @Input() isCheckIn: boolean;
  @Input() partialReserve: boolean;
  @Output() itemToPartial = new EventEmitter<number>();

  public formatDate = formatArrivalDate;

  constructor(private itineraryService: ItineraryService) { }

  ngOnInit() {
    //console.log(this.dato);
    //console.log('valor==>',this.dato);
  }

  removeItem(item: any) {
    console.log(item);
    this.itineraryService.remove(item);
  }

  toPartialReserve(event, item: any){
    if ( event.target.checked ) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item,true);
      this.itemToPartial.emit(-1);
    }
  }

  fontPrice(price){
    if((price.length - 6) > 0){
      const fact = price.length - 6
      const size = 25 - (1.5 * fact)
      return size + 'px'
    }
  }
}
